import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import style from "./SliderArrow.module.css";

function SliderArrow({ clickHandler, position }) {
  return (
    <button
      onClick={clickHandler}
      className={
        style.btn + " " + (position === "right" ? style.right : style.left)
      }
    >
      {position === "right" ? <IoIosArrowForward /> : <IoIosArrowBack />}
    </button>
  );
}

export default SliderArrow;
